import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store';
import { selectAuthUser } from '../../store/slices/auth/auth.selector';

interface Props {
  to: 'projects' | 'dashboard';
}

/**
 * A helper component to redirect to PMO routes with the user's orgSlug.
 */
export const PmoRedirect: React.FC<Props> = ({ to }) => {
  const user = useAppSelector(selectAuthUser);
  const orgSlug = user?.orgSlug ?? 'org';

  if (to === 'projects') {
    return <Navigate to={`/${orgSlug}/pmo/projects`} replace />;
  }

  return <Navigate to={`/${orgSlug}/dashboard`} replace />;
};
